import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import {
  AiListeningBrandProfileApiService,
  DateRangeParams,
} from 'src/services/aiListeningApi/brandProfile'

export const useGetAiListeningProfilePromptsOverviewQuery = (
  profileId: string | undefined,
  { from, to }: DateRangeParams = {}
) => {
  return useQuery({
    enabled: !!profileId,
    placeholderData: keepPreviousData,
    queryFn: () =>
      AiListeningBrandProfileApiService.getPromptsOverview(profileId ?? '', {
        from,
        to,
      }),
    queryKey: [
      QueryKey.GET_AI_LISTENING_PROFILE_PROMPTS_OVERVIEW,
      profileId,
      from,
      to,
    ],
  })
}
